
import { images } from "../constants";

const destinations = [
    {
        id: 1,
        image: images.des1,
        title: "Spain",
        details: {
            location: "Spain, Europe",
            terrainType: "Beaches, Mountains, Plains, Historical Cities",
            Cuisine: "Tapas, Paella, Gazpacho, Jamón Ibérico",
            idealDuration: "7 - 14 Days",
            languageSpoken: "Spanish",
            currency: "Euro (EUR)",
            budget: "€500 - €2000",
            bestSeason: "Spring (April-June) & Fall (September-October)",
        },
        overviews: [
            "Experience the vibrant culture, rich history, and diverse landscapes of Spain. From the architectural marvels of Barcelona and Madrid to the sun-kissed beaches of Costa del Sol and the serene countryside of Andalusia, Spain offers a captivating blend of tradition and modernity."
        ],
        attractions: [
            "La Sagrada Familia and Gothic Quarter (Barcelona)",
            "Royal Palace and Prado Museum (Madrid)",
            "Alhambra Palace (Granada)",
            "Sunny Beaches of Costa Brava and Costa del Sol",
            "Festivals like La Tomatina & Running of the Bulls"
        ],
        climate: [
            "Mediterranean Climate with Hot Summers & Mild Winters",
            "Pleasant Spring and Autumn with Moderate Temperatures",
            "Occasional Rainfall in Northern Regions",
            "Cooler Temperatures in Mountain Areas",
            "Summer Temperatures can Reach up to 40°C (104°F)"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12211477.113249719!2d-9.392883394678403!3d40.46366700000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd4229978f429a01%3A0x402b0a5a4a1d150!2sSpain!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        gallery: [
            images.des1Gallery1,
            images.des1Gallery2,
            images.des1Gallery3,
            images.des1Gallery4,
            images.des1Gallery5,
            images.des1Gallery6,
        ],
    },
    {
        id: 2,
        image: images.des2,
        title: "United Arab Emirates",
        details: {
            location: "UAE, Middle East",
            terrainType: "Deserts, Coastal Plains, Urban Skyscrapers, Artificial Islands",
            elevationRange: "Sea Level to 1,910 m (Jebel Jais Peak)",
            Cuisine: "Shawarma, Mandi, Harees, Luqaimat",
            idealDuration: "5 - 10 Days",
            languageSpoken: "Arabic (English widely spoken)",
            currency: "UAE Dirham (AED)",
            budget: "$800 - $3000",
            bestSeason: "November to March (Winter Season)"
        },
        overviews: [
            "Discover the modern marvels and rich heritage of the United Arab Emirates. From the towering Burj Khalifa in Dubai to the cultural treasures of Abu Dhabi and the serene deserts of Ras Al Khaimah, UAE is a blend of futuristic innovation and traditional Arabian charm."
        ],
        attractions: [
            "Burj Khalifa and Dubai Mall",
            "Sheikh Zayed Grand Mosque (Abu Dhabi)",
            "Palm Jumeirah & Atlantis Resort",
            "Desert Safaris & Dune Bashing Adventures",
            "Ferrari World & Yas Island (Abu Dhabi)"
        ],
        climate: [
            "Hot Desert Climate with Scorching Summers",
            "Mild and Pleasant Winters (Ideal for Tourism)",
            "Occasional Rainfall during Winter Months",
            "High Humidity Levels in Coastal Areas",
            "Daytime Temperatures can Exceed 45°C in Summer"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11578077.95109896!2d48.258523710897456!3d23.424076!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f4345b2e6c3f7%3A0x1aee504dd7e109e5!2sUnited%20Arab%20Emirates!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        gallery: [
            images.des2Gallery1,
            images.des2Gallery2,
            images.des2Gallery3,
            images.des2Gallery4,
            images.des2Gallery5,
            images.des2Gallery6,
        ],
    },
    {
        id: 3,
        image: images.des3,
        title: "Indonesia",
        details: {
            location: "Indonesia, Southeast Asia",
            terrainType: "Volcanic Mountains, Tropical Beaches, Rainforests, Rice Terraces",
            elevationRange: "Sea Level to 3,726 m (Mount Rinjani)",
            Cuisine: "Nasi Goreng, Satay, Rendang, Gado-Gado",
            idealDuration: "7 - 14 Days",
            languageSpoken: "Bahasa Indonesia (English in tourist areas)",
            currency: "Indonesian Rupiah (IDR)",
            budget: "$500 - $2000",
            bestSeason: "May to September (Dry Season)"
        },
        overviews: [
            "Explore the archipelago of Indonesia, a land of stunning beaches, active volcanoes, lush jungles, and vibrant culture. Whether you’re visiting the serene temples of Bali, trekking through Sumatra’s rainforests, or diving in the coral-rich waters of Raja Ampat, Indonesia offers diverse experiences for every traveler."
        ],
        attractions: [
            "Uluwatu Temple & Beaches of Bali",
            "Borobudur & Prambanan Temples (Java)",
            "Komodo National Park & Pink Beach",
            "Mount Bromo Sunrise Trek",
            "Scuba Diving in Raja Ampat"
        ],
        climate: [
            "Tropical Climate with High Humidity",
            "Dry Season (May to September) is Best for Travel",
            "Wet Season (October to April) with Heavy Rains",
            "Coastal Areas Remain Warm Year-Round",
            "Mountainous Areas are Cooler with Frequent Showers"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12675780.861096535!2d95.0128857151611!3d-0.7892750000000001!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2c4c07f84f5361c5%3A0x3c6c46d64d2c57c1!2sIndonesia!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        gallery: [
            images.des3Gallery1,
            images.des3Gallery2,
            images.des3Gallery3,
            images.des3Gallery4,
            images.des3Gallery5,
            images.des3Gallery6,
        ],
    },
    {
        id: 4,
        image: images.des4,
        title: "Greece",
        details: {
            location: "Greece, Europe",
            terrainType: "Islands, Beaches, Mountains, Ancient Ruins",
            elevationRange: "Sea Level to 2,917 m (Mount Olympus)",
            Cuisine: "Moussaka, Souvlaki, Tzatziki, Baklava",
            idealDuration: "7 - 12 Days",
            languageSpoken: "Greek (English widely understood in tourist areas)",
            currency: "Euro (EUR)",
            budget: "€700 - €2500",
            bestSeason: "May to October (Best: Late Spring & Early Fall)"
        },
        overviews: [
            "Greece, the cradle of Western civilization, is renowned for its ancient ruins, sun-drenched islands, and rich Mediterranean culture. Wander through the historical streets of Athens, relax on the iconic beaches of Santorini, and discover charming villages across the Cyclades."
        ],
        attractions: [
            "Acropolis & Parthenon (Athens)",
            "Santorini’s Whitewashed Cliffs and Sunsets",
            "Mykonos Windmills & Vibrant Nightlife",
            "Delphi Archaeological Site",
            "Beaches & Blue Caves of Zakynthos"
        ],
        climate: [
            "Mediterranean Climate with Hot, Dry Summers",
            "Mild, Rainy Winters in Mainland Areas",
            "Island Regions Enjoy Long Sunny Days",
            "Spring & Autumn Offer Pleasant Temperatures",
            "Peak Tourist Season in July-August"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12376397.892518835!2d20.819500168911184!3d39.074208!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x135b4aad49c3b1e7%3A0x363d87ad71b95c6!2sGreece!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        gallery: [
            images.des4Gallery1,
            images.des4Gallery2,
            images.des4Gallery3,
            images.des4Gallery4,
            images.des4Gallery5,
            images.des4Gallery6,
        ],
    },
    {
        id: 5,
        image: images.des5,
        title: "Italy",
        details: {
            location: "Italy, Europe",
            terrainType: "Rolling Hills, Mountains, Coastal Cliffs, Historic Cities",
            elevationRange: "Sea Level to 4,810 m (Mont Blanc - Italy side)",
            Cuisine: "Pizza, Pasta, Gelato, Risotto, Tiramisu",
            idealDuration: "10 - 14 Days",
            languageSpoken: "Italian (English in tourist regions)",
            currency: "Euro (EUR)",
            budget: "€1000 - €3000",
            bestSeason: "April to June & September to October"
        },
        overviews: [
            "Italy, a land of art, history, and culinary delights, offers an unforgettable journey through time. From the ancient ruins of Rome and the romantic canals of Venice to the rolling vineyards of Tuscany and the stunning Amalfi Coast, Italy blends culture, architecture, and natural beauty in perfect harmony."
        ],
        attractions: [
            "Colosseum & Roman Forum (Rome)",
            "Vatican City & St. Peter's Basilica",
            "Canals of Venice & St. Mark's Square",
            "Leaning Tower of Pisa",
            "Tuscany's Vineyards & Florence's Art Museums",
            "Amalfi Coast & Cinque Terre"
        ],
        climate: [
            "Mediterranean Climate with Hot, Dry Summers",
            "Mild, Wet Winters Especially in the North",
            "Spring & Fall Offer Comfortable Weather for Sightseeing",
            "Southern Italy is Warmer Year-Round",
            "July & August are Peak Tourist Months"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11948661.171257742!2d7.668416938887769!3d41.87194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132f619ed65b0c65%3A0x4216fb167f3c99fb!2sItaly!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        gallery: [
            images.des5Gallery1,
            images.des5Gallery2,
            images.des5Gallery3,
            images.des5Gallery4,
            images.des5Gallery5,
            images.des5Gallery6,
        ],
    },
    {
        id: 6,
        image: images.des6,
        title: "Thailand",
        details: {
            location: "Thailand, Southeast Asia",
            terrainType: "Tropical Beaches, Mountains, Rainforests, Vibrant Cities",
            elevationRange: "Sea Level to 2,565 m (Doi Inthanon Peak)",
            Cuisine: "Pad Thai, Tom Yum Soup, Green Curry, Mango Sticky Rice",
            idealDuration: "7 - 12 Days",
            languageSpoken: "Thai (English in tourist areas)",
            currency: "Thai Baht (THB)",
            budget: "$500 - $2000",
            bestSeason: "November to February (Cool Dry Season)"
        },
        overviews: [
            "Thailand is a land of golden temples, bustling street markets, serene beaches, and lush jungles. Whether you’re exploring the vibrant streets of Bangkok, relaxing on the islands of Phuket and Krabi, or trekking through the mountains of Chiang Mai, Thailand offers a perfect mix of adventure and relaxation."
        ],
        attractions: [
            "Grand Palace & Wat Pho (Bangkok)",
            "Phi Phi Islands & Maya Bay",
            "Chiang Mai Old City & Elephant Sanctuaries",
            "Floating Markets & Street Food Tours",
            "Ayutthaya Historical Park"
        ],
        climate: [
            "Tropical Climate with Hot, Humid Summers",
            "Cool Dry Season from November to February",
            "Hot Season from March to May with Temperatures over 35°C",
            "Rainy Season from June to October (Heavy Showers)",
            "Southern Thailand Experiences Monsoon Variations"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d12656369.227074739!2d97.34509313793995!3d15.870032!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29edbe4ef9b0d%3A0xa33a8b44f57c592e!2sThailand!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        gallery: [
            images.des6Gallery1,
            images.des6Gallery2,
            images.des6Gallery3,
            images.des6Gallery4,
            images.des6Gallery5,
            images.des6Gallery6,
        ],
    },
    {
        id: 7,
        image: images.des7,
        title: "Egypt",
        details: {
            location: "Egypt, North Africa",
            terrainType: "Deserts, River Valleys, Coastal Plains, Ancient Monuments",
            elevationRange: "Sea Level to 2,629 m (Mount Catherine)",
            Cuisine: "Koshari, Ful Medames, Molokhia, Ta’ameya (Egyptian Falafel)",
            idealDuration: "7 - 10 Days",
            languageSpoken: "Arabic (English in tourist areas)",
            currency: "Egyptian Pound (EGP)",
            budget: "$600 - $2000",
            bestSeason: "October to April (Cool Season)"
        },
        overviews: [
            "Egypt, the land of Pharaohs, is a treasure trove of ancient wonders and timeless landscapes. From the majestic Pyramids of Giza and the temples of Luxor to the tranquil Nile cruises and bustling bazaars of Cairo, Egypt blends history, culture, and natural beauty like no other."
        ],
        attractions: [
            "Pyramids of Giza & The Sphinx",
            "Egyptian Museum (Cairo)",
            "Luxor’s Karnak & Valley of the Kings",
            "Abu Simbel Temples",
            "Nile River Cruises & Felucca Rides"
        ],
        climate: [
            "Desert Climate with Hot, Dry Summers",
            "Mild Winters (Ideal for Sightseeing)",
            "Nile Delta Region is Slightly More Humid",
            "Sandstorms Possible in Spring (Khamsin Winds)",
            "Best Travel Period is from October to April"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11474912.320128065!2d25.12312990444551!3d26.820553!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14583b9e89d6533b%3A0xe4081e2e17a7b8a7!2sEgypt!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        gallery: [
            images.des7Gallery1,
            images.des7Gallery2,
            images.des7Gallery3,
            images.des7Gallery4,
            images.des7Gallery5,
            images.des7Gallery6,
        ],
    },
    {
        id: 8,
        image: images.des8,
        title: "Mexico",
        details: {
            location: "Mexico, North America",
            terrainType: "Beaches, Mountains, Deserts, Jungles, Colonial Cities",
            elevationRange: "Sea Level to 5,636 m (Pico de Orizaba)",
            Cuisine: "Tacos, Mole, Tamales, Chiles en Nogada, Guacamole",
            idealDuration: "7 - 14 Days",
            languageSpoken: "Spanish (English in tourist regions)",
            currency: "Mexican Peso (MXN)",
            budget: "$700 - $2500",
            bestSeason: "November to April (Dry Season)"
        },
        overviews: [
            "Mexico is a country rich in cultural heritage, ancient ruins, vibrant cities, and stunning coastlines. From the historic sites of Chichen Itza and the colorful streets of Mexico City to the pristine beaches of Cancun and the jungles of Chiapas, Mexico offers a diverse and captivating travel experience."
        ],
        attractions: [
            "Chichen Itza & Mayan Ruins (Yucatan)",
            "Cancun & Riviera Maya Beaches",
            "Mexico City’s Historic Center & Frida Kahlo Museum",
            "Copper Canyon Railway Adventure",
            "Day of the Dead Celebrations (Dia de los Muertos)"
        ],
        climate: [
            "Varied Climate: Tropical in the South, Desert in the North",
            "Dry Season from November to April",
            "Rainy Season from May to October (especially in the South)",
            "Coastal Areas are Warm Year-Round",
            "Highland Areas (Mexico City, Oaxaca) are Cooler"
        ],
        locationMap: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11402117.449735528!2d-117.16108784036842!3d23.634501!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d1f92b3c4f98e3%3A0x43423fcf04e3e8a3!2sMexico!5e0!3m2!1sen!2sus!4v1715802467890!5m2!1sen!2sus",
        gallery: [
            images.des8Gallery1,
            images.des8Gallery2,
            images.des8Gallery3,
            images.des8Gallery4,
            images.des8Gallery5,
            images.des8Gallery6,
        ],
    }

];

export default destinations;